import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Colors } from '../../../../../../themes/colors';
import { filterObjectKeys } from '../../../../../../utils';
import { EducationUtils } from '../../../../../../utils/EducationUtils';
import { EditableField } from '../../../../../commonComponents/EditableField';
import { jobTitleMaxLength } from '../../../shared/constants';
import { FormCard } from '../../../shared/FormCard';
import { InfoRow } from '../../../shared/InfoRow';
import { getProfessionName } from '../../../shared/utils';

export const GeneralInformationCard = ({
  formValues,
  handleChange,
  isEditing,
  job,
  onCancelClick,
  onEditClick,
  onSaveClick,
}) => {
  const userEducation = useSelector((state) => state.users.userEducation);

  const availableSpecialties = Object.keys(
    filterObjectKeys(userEducation?.specialtiesAndProcedures, 'specialty'),
  );

  const isFormValid = useMemo(
    () => !!formValues.jobTitle && !!formValues.professionType && !!formValues.officeSpecialty,
    [formValues.jobTitle, formValues.officeSpecialty, formValues.professionType],
  );

  return (
    <FormCard title="General Job Information" style={{ marginTop: '16px' }}>
      <div>
        <InfoRow>
          <span className="semi-bold">Office Name:</span>
          {job?.officeId ? (
            <a href={`/user/dentist/${job?.officeId}`}>{job?.officeName || '-'}</a>
          ) : (
            <span>-</span>
          )}
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">
            Job Listing Title{isEditing && <span style={{ color: Colors.error_500 }}>*</span>}:
          </span>
          <EditableField
            editing={isEditing}
            view={<span>{job?.title || '-'}</span>}
            edit={
              <input
                className="form-control"
                maxLength={jobTitleMaxLength}
                placeholder="Job Listing Title"
                style={{ width: 315 }}
                type="text"
                value={formValues?.jobTitle || ''}
                onChange={(e) => handleChange('jobTitle', e.target.value)}
              />
            }
          />
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">Professional Type:</span>
          <EditableField view={<span>{getProfessionName(job) ?? '-'}</span>} />
        </InfoRow>

        <InfoRow>
          <span className="semi-bold">
            Office Specialty{isEditing && <span style={{ color: Colors.error_500 }}>*</span>}:
          </span>
          <EditableField
            editing={isEditing}
            view={
              <span>
                {job?.specialty ? EducationUtils.removeSpecialtyPrefix(job.specialty) : '-'}
              </span>
            }
            edit={
              <select
                className="custom-select custom-select-lg"
                style={{ height: 32, width: 200 }}
                value={formValues?.officeSpecialty || ''}
                onChange={(val) => handleChange('officeSpecialty', val.target.value)}
              >
                {availableSpecialties.map((specialty) => (
                  <option key={specialty} value={specialty}>
                    {EducationUtils.removeSpecialtyPrefix(specialty)}
                  </option>
                ))}
              </select>
            }
          />
        </InfoRow>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
        {isEditing ? (
          <div style={{ display: 'flex', alignSelf: 'center', gap: 10 }}>
            <button
              type="button"
              className="btn btn-danger"
              style={{ width: 100 }}
              onClick={onCancelClick}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-info"
              style={{ width: 100 }}
              onClick={onSaveClick}
              disabled={!isFormValid}
            >
              Save
            </button>
          </div>
        ) : (
          <button
            type="button"
            className="btn btn-info"
            style={{ width: 150, alignSelf: 'center' }}
            onClick={onEditClick}
          >
            Edit
          </button>
        )}
      </div>
    </FormCard>
  );
};
